import { useEffect, useRef, useState } from "react";
import { BackButtonPage } from "components/__new/common/BackButton";
import { Input, ButtonLoader } from "components/__new/common/form";
import useBackButton from "hooks/useBackButton";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { useDispatch, useSelector } from "react-redux";
import useLoginInfo from "hooks/useLoginInfo";
import Maybe from "components/__new/common/Maybe";
import { toast } from "react-toastify";
import PinModal from "components/__new/common/PinModal";
import ModalAlert from "components/__new/common/ModalAlert";
import SearchableBanks from "components/__new/common/dropdown-search/Banks";
import maskEmailAddress from "utils/maskData";
import * as walletAction from "store/entities/wallet/action";


export const WalletBeneficiaryForm = () => {
    const {goBack} = useBackButton();
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const searchableBanksRef = useRef();


    const { accountValidationLoading, accountValidation, otpGenerationLoading, otpGeneration, beneficiaryCreateLoading, beneficiaryCreate } = useSelector((s) => s.entities.wallet);

    const [isOpenOtp, setIsOpenOtp] = useState(false);
    const [isOpenModalAlert, setIsOpenModalAlert] = useState(false);
    const [form, setForm] = useState({
        bank: {},
        accountNumber: "",
        accountName: "",
        otp: "",
    })


    const getAccountInfo = (bankSelected, accountNumberTyped) => {
        const bank = bankSelected || form.bank;
        const accountNumber = accountNumberTyped || form.accountNumber;
        let newForm = {
            ...form,
            bank,
            accountNumber,
        }

        if (bank.value !== "" && accountNumber.length === 10){
            const params = {bankCode: bank.value, accountNumber};
            dispatch(walletAction.validateAccount(userInfo.token, params));
        }
        else{
            newForm = {...newForm, accountName: ""};
        }
        
        setForm(newForm);
    }


    const submitForm = async (e) => {
        e.preventDefault();
        dispatch(walletAction.generateOtp(userInfo.token, "beneficiary"));
    }
    
    
    const submitOtp = () => {
        const params = {
            accountName: form.accountName,
            accountNumber: form.accountNumber,
            bankName: form.bank.label,
            bankCode: form.bank.value,
            otp: form.otp,
        };
        dispatch(walletAction.createBeneficiary(userInfo.token, params));
    }


    useEffect(() => {
        if (accountValidation?.status === "success" && accountValidation?.data){
            const accountName = accountValidation?.data.account_name;
            setForm({...form, accountName});
        }
        // eslint-disable-next-line
    }, [accountValidation])


    useEffect(() => {
        // if (otpGeneration?.status === "success" && otpGeneration?.data){
        if (otpGeneration?.error === false && otpGeneration?.data){
            setIsOpenOtp(true);
            dispatch(walletAction.generateOtpReset());
        }
        // eslint-disable-next-line
    }, [otpGeneration])


    useEffect(() => {
        if (beneficiaryCreate?.status === "success" && beneficiaryCreate?.data){
            setIsOpenOtp(false);
            setIsOpenModalAlert(true);
            setForm({
                bank: {},
                accountNumber: "",
                accountName: "",
                otp: "",
            })
            dispatch(walletAction.createBeneficiaryReset());
            searchableBanksRef.current?.clearSearchableBanks();
        }
        // eslint-disable-next-line
    }, [beneficiaryCreate])


    return (
        <div>

            <DynamicHeadTag
                headerText="Add Beneficiary | Wallet"
            />


            <PinModal
                target="OTP"
                title="Enter OTP"
                description={"Enter OTP sent to " + maskEmailAddress(userInfo?.member?.email)}
                pin={(e) => setForm({...form, otp: e})}
                submit={submitOtp}
                loading={beneficiaryCreateLoading}
                isOpenPin={isOpenOtp}
                setIsOpenPin={setIsOpenOtp}
            />


            <ModalAlert
                successText="New beneficiary added successfully"
                dismissText="Create Another"
                isOpenModalAlert={isOpenModalAlert}
                setIsOpenModalAlert={setIsOpenModalAlert}
            />


            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex">
                        <BackButtonPage />
                        Add Beneficiary
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <form onSubmit={submitForm} className="mt-6 box" style={{overflow: "visible"}}>
                <div>
                    Enter all beneficiary details here. 
                </div>
                <div className="mt-2">
                    <span className="text-ep-primary font-semibold">Hint:</span> You need to complete setup to be able to transfer to this beneficiary
                </div>

                <div className="mt-10 max-w-lg">
                    <div className="font-semibold mb-4">
                        Bank Details
                    </div>

                    <div className="mb-4">
                        <SearchableBanks
                            ref={searchableBanksRef}
                            onValueChange={(e) => getAccountInfo(e, undefined)}
                        />
                    </div>

                    <div className="mb-4">
                        <Input type="text" label="Account Number" placeholder="Enter beneficiary account number" value={form.accountNumber} onChange={(e) => getAccountInfo(undefined, e.target.value)} />
                    </div>

                    <div className="mb-4">
                        {accountValidationLoading === true && <Input type="text" label="Account Name" value="Loading..." disabled />}
                        {accountValidationLoading === false && <Input type="text" label="Account Name" value={form.accountName} disabled />}
                    </div>


                    <div className="mt-10 flex space-x-4">
                        <Maybe condition={form.accountName !== ""}>
                            <ButtonLoader type="submit" loading={otpGenerationLoading} className="btn btn-ep-primary">
                                Add Beneficiary
                            </ButtonLoader>
                        </Maybe>
                        <Maybe condition={form.accountName === ""}>
                            <ButtonLoader type="button" loading={false} className="btn btn-ep-primary disabled" disabled={true} onClick={() => toast.error("Please enter valid account info")}>
                                Add Beneficiary
                            </ButtonLoader>
                        </Maybe>
                        <button type="button" onClick={goBack} className="btn btn-transparent-primary">
                            Cancel
                        </button>
                    </div>

                </div>
            </form>


        </div>
    )
}




export default WalletBeneficiaryForm;